import { z } from "zod";

export const pinCodeSchema = z.object({
  code: z.string().trim().min(4).max(4),
});
